module.exports = __webpack_public_path__ + "img/tripe_win_en.85751c27.svg";